import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const MenuIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M3 12h18M3 6h18M3 18h18"
    />
  </svg>
);
